package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.FormsDemoGridStyle
import com.anjuros.website.redesign.styles.FormsTabActiveStyle
import com.anjuros.website.redesign.styles.FormsTabStyle
import com.anjuros.website.redesign.styles.FormsTabsStyle
import com.anjuros.website.redesign.styles.RdFaqBandStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/**
 * Example forms for different trades. Changing an answer updates the email preview beside it,
 * so visitors see exactly what they'd receive. Nothing is sent.
 */
@Composable
fun ContactFormsDemoSection() {
    var selected by remember { mutableStateOf(DEFAULT_DEMO_FORM) }
    var sent by remember { mutableStateOf(false) }
    // Answers changed by the visitor, keyed by form id and field index; untouched fields show their example answer.
    // A plain state value holding an immutable map: mutableStateMapOf fails at runtime with this project's Compose version.
    var answers by remember { mutableStateOf(mapOf<String, String>()) }
    val form = DemoForms[selected]

    val values = form.fields.mapIndexed { index, field -> answers["${form.id}-$index"] ?: LocalText(field.initial) }

    RdSection(id = "demo", labelledBy = "demo-h", modifier = RdSectionStyle.toModifier().then(RdFaqBandStyle.toModifier())) {
        RdSectionHead(RdText.FORMS_DEMO_EYEBROW, "demo-h", RdText.FORMS_DEMO_TITLE, RdText.FORMS_DEMO_LEDE)
        Tabs(selected) { index ->
            selected = index
            sent = false
        }
        Div(FormsDemoGridStyle.toModifier().toAttrs()) {
            DemoFormView(
                form = form,
                values = values,
                onChange = { index, value -> answers = answers + ("${form.id}-$index" to value) },
                sent = sent,
                onSubmit = { sent = true },
            )
            InboxPreview(form, values)
        }
    }
}

@Composable
private fun Tabs(selected: Int, onSelect: (Int) -> Unit) {
    val label = LocalText(RdText.FORMS_DEMO_TABS_LABEL)
    Div(FormsTabsStyle.toModifier().attrsModifier { attr("role", "tablist"); attr("aria-label", label) }.toAttrs()) {
        DemoForms.forEachIndexed { index, demo ->
            Button(
                FormsTabStyle.toModifier()
                    .thenIf(index == selected, FormsTabActiveStyle.toModifier())
                    .attrsModifier {
                        attr("type", "button")
                        attr("role", "tab")
                        attr("aria-selected", (index == selected).toString())
                    }
                    .onClick { onSelect(index) }
                    .toAttrs()
            ) { Text(LocalText(demo.tab)) }
        }
    }
}
